import { useCreate } from '../../../api';

export const useCreateLetter = (msg?: string) => {
  const {
    mutateAsync: createLetter,
    isLoading: isCreatingLetter,
    error,
  } = useCreate({
    url: 'letter-generation/employees/letter-requests',
    customInvalidateQueriesUrl: 'letter-generation/employees/letter-requests',
    msg,
  });

  return {
    isCreatingLetter,
    error,
    createLetter,
  };
};
